import { render, staticRenderFns } from "./corredizo.vue?vue&type=template&id=ce9e0bf6&scoped=true&"
import script from "./corredizo.vue?vue&type=script&lang=js&"
export * from "./corredizo.vue?vue&type=script&lang=js&"
import style0 from "./corredizo.vue?vue&type=style&index=0&id=ce9e0bf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9e0bf6",
  null
  
)

export default component.exports